
<template>
  <div :style="mainContentViewHeight" class="main_center">
     <div style="background-color:#FFF;">
        <searchBox :dialogVisible.sync="moreSearchItem" @dialogCancle="dialogCancle" title="更多筛选">
      <div class="search-drawer">
        <el-form :model="form" label-position="top" ref="form">
          <el-form-item label="关键字搜索：">
            <el-input clearable placeholder="请输入奖励/违规/处罚事项名称" v-model="form.keywords"></el-input>
          </el-form-item>
        </el-form>
        <div class="search-drawer__footer">
          <el-button @click="searchBtn" size="small" type="primary">搜索</el-button>
          <el-button @click="refresh" plain size="small">刷新</el-button>
        </div>
      </div>
    </searchBox>
    <div class="punish-info-tabs">
    <div class="list_top">
        <div class="pageTitle">信用红黑榜</div>
      <div class="searchBtn centerSearch">
        <el-input
          @keyup.enter.native="searchBtn"
          clearable
          placeholder="请输入请输入奖励/违规/处罚事项名称/实施认定部门/相关文件文号/企业名称"
          style="width: 525px"
          v-model="form.keywords"
        ></el-input>
        <el-button @click="searchBtn" class="rightSearchBtn" size="small" type="primary">搜索</el-button>
        <el-button
          @click="moreSearchItem = true"
          icon="el-icon-arrow-down"
          size="mini"
          type="text"
          class="height_four"
        >更多搜索</el-button>
        <el-divider direction="vertical"></el-divider>
        <el-button @click="refresh" icon="el-icon-refresh" type="text" class="height_four"></el-button>
      </div>
    </div>
      <el-tabs v-model="checkName" @tab-click="changeName" style="height:40px;">
        <el-tab-pane label="奖励信息" name="1"></el-tab-pane>
        <el-tab-pane label="违法违规" name="2"></el-tab-pane>
        <el-tab-pane label="行政处罚" name="3"></el-tab-pane>
        <el-tab-pane label="黑名单" name="4"></el-tab-pane>
      </el-tabs>
    </div>
     </div>
    <div class="tableContent_">
    <rewardInfoList ref="rewardInfoListRef" v-if="checkName==='1'" />
    <violationList ref="violationListRef" v-if="checkName==='2'" />
    <sanctioList ref="sanctioListRef" v-if="checkName==='3'" />
    <blackList ref="balckListRef" v-if="checkName==='4'" />
    </div>
  </div>
</template>

<script>
import rewardInfoList from "./rewardInfo/rewardInfoList";
import blackList from "./black/blackList";
import sanctioList from "./sanctio/sanctioList";
import violationList from "./violation/violationList";
export default {
  props: ["mainContentViewHeight"],
  components: {
    blackList,
    rewardInfoList,
    sanctioList,
    violationList
  },
  data() {
    return {
      checkName: "1",
      moreSearchItem: false,
      pageSize: 10, //每页条数
      pageIndex: 1, //当前页
      total: 0, //总条数
      form: {
        keywords: "",
        flowName: ""
      },
      myMap: new Map()
    };
  },
  activated() {
    if (this.$route.query.type) {
      this.checkName = this.$route.query.type;
    }
  },
  mounted() {
    // setTimeout(()=>{
    //   this.myMap.set("1", this.$refs.rewardInfoListRef.getDataList());
    //   this.myMap.set("2", this.$refs.violationListRef.getDataList());
    //   this.myMap.set("3", this.$refs.sanctioListRef.getDataList());
    //   this.myMap.set("4", this.$refs.balckListRef.getDataList());
    // },1000)
  },
  methods: {
    // 切换信用信息
    changeName(value) {
      this.checkName = value.name;
      let val = value.name;
      this.$nextTick(() => {
        if (val == "1") {
          this.$refs.rewardInfoListRef.getDataList(this.form.keywords);
        }
        if (val == "2") {
          this.$refs.violationListRef.getDataList(this.form.keywords);
        }
        if (val == "3") {
          this.$refs.sanctioListRef.getDataList(this.form.keywords);
        }
        if (val == "4") {
          this.$refs.balckListRef.getDataList(this.form.keywords);
        }
      });
    },
    //搜索按钮
    searchBtn() {
      this.pageIndex = 1;
      this.moreSearchItem = false;
      // // this.getDataList();\
      // this.myMap.get(this.checkName);
      if (this.checkName === "1") {
        this.$refs.rewardInfoListRef.getDataList(this.form.keywords);
      }
      if (this.checkName == "2") {
        this.$refs.violationListRef.getDataList(this.form.keywords);
      }
      if (this.checkName == "3") {
        this.$refs.sanctioListRef.getDataList(this.form.keywords);
      }
      if (this.checkName == "4") {
        this.$refs.balckListRef.getDataList(this.form.keywords);
      }
    },

    refresh() {
      //刷新按钮
      this.pageIndex = 1;
      this.moreSearchItem = false;
      this.form.keywords = "";
      // this.getDataList();
      // this.myMap.get(this.checkName);
      if (this.checkName === "1") {
        this.$refs.rewardInfoListRef.getDataList(this.form.keywords);
      }
      if (this.checkName == "2") {
        this.$refs.violationListRef.getDataList(this.form.keywords);
      }
      if (this.checkName == "3") {
        this.$refs.sanctioListRef.getDataList(this.form.keywords);
      }
      if (this.checkName == "4") {
        this.$refs.balckListRef.getDataList(this.form.keywords);
      }
    },
    dialogCancle() {
      this.moreSearchItem = false;
    }
  }
};
</script>
<style lang="scss">
.punish-info-tabs{
    .centerSearch{
        .el-input .el-input__inner, .el-input--medium .el-input__inner, .el-input--suffix .el-input__inner{
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
    }
    .rightSearchBtn{
        height:40px;
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
    }
    .height_four{
      height: 40px;
    }
     .el-input--medium .el-input__inner{
            height: 40px;
            line-height: 40px;
        }
    }
}
</style>
<style lang="scss" scoped>
.main_center {
//   padding-top: 16px;

}

.punish-info-tabs {
  padding: 0 24px;
  padding-top:24px;
  position: relative;
  background: #ffffff;
  // box-shadow: 0 2px 4px 0 rgba(0, 0, 0, .12), 0 0 6px 0 rgba(0, 0, 0, .04);
  .pageTitle{
        font-size: 18px;
        font-weight: 600;
        color: #000000; 
        height: 40px; 
    }
    .list_top{
        display: flex;
        align-items: center;
    }
  .searchBtn {
    width: calc(100% - 100px);
    display: flex;
    justify-content: center;
    align-items: center;
    align-self: center;
  }
 
 
}
</style>
